import request from '@/router/axios'
import env from '@/config/env'

// 列表
export function notificationsPage(data) {
  return request({
    url: env.ferryUrl + '/notifications/page',
    method: 'post',
    data
  })
}

// 详情
export function notificationsById(id) {
  return request({
    url: env.ferryUrl + '/notifications/' + id,
    method: 'get'
  })
}

// 添加
export function addNotifications(data) {
  return request({
    url: env.ferryUrl + '/notifications',
    method: 'post',
    data
  })
}

// 修改
export function updateNotifications(id, data) {
  return request({
    url: env.ferryUrl + '/notifications/' + id,
    method: 'put',
    data
  })
}

// 删除
export function delNotifications(id) {
  return request({
    url: env.ferryUrl + '/notifications/' + id,
    method: 'delete'
  })
}

// 删除
export function analysisExcel(params) {
  return request({
    url: env.ferryUrl + '/notifications/analysisExcel',
    method: 'get',
    params
  })
}

// 获取通知定时发送最晚时间
export function postDeadlineForSend(data) {
  return request({
    url: env.ferryUrl + '/notifications/deadlineForSend',
    method: 'post',
    data
  })
}
